import { useState } from 'react';
import { Button } from '@primer/react';
import { Logo } from '../components/UI';
import { parseAuthCallback, nativeAuthLink } from './authCallback';

/** Only a one-use PKCE code crosses to iOS. The browser never exchanges it or receives tokens. */
export function NativeAuthCallback() {
  const [link] = useState(() => nativeAuthLink(window.location.search));
  const [error] = useState(() => parseAuthCallback(window.location.search).error);
  return (
    <main className="callback-page">
      <Logo variant="stacked" />
      <h1>{link ? 'Return to your garage' : 'This link could not be used'}</h1>
      <p>
        {error ||
          (link
            ? 'Open Garage Gym Bros on the device where you signed up to finish signing in.'
            : 'Request a new verification email from the app.')}
      </p>
      {link && (
        <Button as="a" href={link} variant="primary">
          Open Garage Gym Bros
        </Button>
      )}
      <p>
        Don’t have the app?{' '}
        <a href="https://apps.apple.com/app/id6828416149">View on the App Store</a>
      </p>
    </main>
  );
}
